import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './batchPrintinvoice.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    practice: [],
    tags: [],
    filter: '',
    format: '',
  });

  const handleChange = (e) => {
    const { name, value, type, options } = e.target;

    if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="bp-wrap">
      <div className="bp-desc">Batch print open invoices by account</div>

      <div className="bp-box">
        <h2 className="bp-title">Parameters</h2>

        <form onSubmit={handleSubmit} className="bp-panel">
          {/* Accounts Selection */}
          <div className="bp-row bp-row-top">
            <label
              className="bp-label"
              htmlFor="practice"
              title="Please choose an account to limit the report to"
            >
              Accounts
            </label>
            <div className="bp-field">
              <select
                id="practice"
                multiple
                name="practice"
                size="10"
                value={formData.practice}
                onChange={handleChange}
                className="bp-multi"
              >
                <option value="0">All</option>
                <option value="144545">2ingis s.a.</option>
                <option value="1">37 Dental and Implant C</option>
                <option value="2">Abacus Dental and Impla</option>
                <option value="3">abc</option>
                <option value="4">Academy Dental Care</option>
                <option value="5">Adrian Popovici</option>
                <option value="6">Affinity Dental Clinic Bas</option>
                <option value="7">Alaska House Dental Pra</option>
                <option value="71159">ALL SAINTS DENTAL</option>
              </select>
            </div>
          </div>

          {/* Account Tags Selection */}
          <div className="bp-row">
            <label className="bp-label" htmlFor="tags" title="Select tags to filter report">
              Account Tags
            </label>
            <div className="bp-field">
              <select
                id="tags"
                name="tags"
                value={formData.tags}
                onChange={handleChange}
                className="bp-select"
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </select>
            </div>
          </div>

          {/* Filter Selection */}
          <div className="bp-row">
            <label className="bp-label" htmlFor="filter" title="Please choose a filter to limit the report">
              Filter
            </label>
            <div className="bp-field">
              <select
                id="filter"
                name="filter"
                value={formData.filter}
                onChange={handleChange}
                className="bp-select"
              >
                <option value="">Select a filter</option>
                <option value="overdue">Overdue Only</option>
              </select>
            </div>
          </div>

          {/* Format Selection */}
          <div className="bp-row">
            <label className="bp-label" htmlFor="format" title="Please choose a display format">
              Format <span className="bp-req">*</span>
            </label>
            <div className="bp-field">
              <select
                id="format"
                name="format"
                value={formData.format}
                onChange={handleChange}
                className="bp-select"
                required
              >
                <option value="">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </select>
            </div>
          </div>

          {/* Submit Button */}
          <div className="bp-row bp-row-run">
            <Link to="/AddRevenueBatchPrint" className="bp-link">
              <button type="submit" className="bp-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportForm;